// src/encounter/ambient/ambient-consent-reporter.tsx
//
// `ambientWindow`: hands the recording-consent check's status (RecordingConsentHost's port) up to the page, so the "Start listening"
// card, which sits outside the panel, can say why Start is off. It reads only; it draws nothing and asks nothing.
import { useEffect } from 'react';
import type { RecordingConsentStatus } from './recording-consent-types';

export function AmbientConsentReporter({ status, onChange }: { status: RecordingConsentStatus; onChange: (status: RecordingConsentStatus) => void }) {
  useEffect(() => {
    onChange(status);
  }, [status, onChange]);
  return null;
}
